import React from "react";
import ModuleHeader from "../components/ModuleHeader/ModuleHeader";
import usePrivateLink from "../config/usePrivateLink";

const tabs = [
  {
    id: "assignment",
    title: "Assignment List",
    icon: "ri-book-open-line",
    path: "/assignment",
    activePaths: [
      "/assignment",
      "/assignment/add",
      "/assignments/view",
      "/assignments/student-status",
    ],
  },
  {
    id: "feedback",
    title: "FeedBack List",
    icon: "ri-book-open-line",
    path: "/feedback",
    activePaths: ["/feedback"],
  },
  {
    id: "banner",
    title: "Banner",
    icon: "ri-banner-2-line",
    path: "/settings/banner",
    activePaths: ["/settings/banner"],
  },
  {
    id: "syllabus",
    title: "Syllabus",
    icon: "ri-book-open-line",
    path: "/syllabus",
    activePaths: ["/syllabus", "/syllabus/add", "/syllabus/update"],
  },
  {
    id: "syllabus_assign",
    title: "Syllabus Tracking",
    icon: "ri-checkbox-multiple-line",
    path: "/syllabus/assign",
    activePaths: [
      "/syllabus/assign",
      "/syllabus/assign/add",
      "/syllabus/assign/update",
    ],
  },
  {
    id: "staff_work_reports",
    title: "Staff Work Reports",
    icon: "ri-file-list-3-line",
    path: "/work/report/list",
    activePaths: ["/work/report/list"],
  },
  {
    id: "Notice Board",
    title: "Notice Board",
    icon: "ri-notification-3-line",
    path: "/notice/board",
    activePaths: ["/notice/board"],
  },
];

export default function AcademicHeader({ children }) {
  return;
  const hasAccess = usePrivateLink();

  const permittedTabs = tabs
    .map((tab) => {
      const accessiblePaths = (tab.activePaths || [tab.path]).filter((route) =>
        hasAccess(route),
      );

      return {
        ...tab,
        path: accessiblePaths[0] || "/",
        access: accessiblePaths.length > 0,
      };
    })
    .filter((tab) => tab.access);

  return (
    <>
      <ModuleHeader tabs={permittedTabs} />
      {children}
    </>
  );
}
